/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaResolucionesFacturacionesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaResolucionesFacturaciones: React.FunctionComponent<ITablaResolucionesFacturacionesVistaProps &
    InjectedIntlProps> = ({
    resolucionesFacturacioness,
    cargarResolucionesFacturaciones,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={resolucionesFacturacioness}
            actions={acciones(
                manejarFormulario,
                cargarResolucionesFacturaciones,
                intl.formatMessage,
                confirmarEliminacion
            )}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaResolucionesFacturaciones);
